import RouterFrame from '../../../../../components/share/RouterFrame.vue'

export default function (service, name) {
  return {
    path: 'kalendarz-widocznosc',
    component: RouterFrame,
    meta: {
      title: 'Ustawienia widoczności',
      icon: 'calendar',
      menuLink: true,
      acl: {
        service: service,
        action: 'get_roles_inspection_visibilities'
      }
    }
  }
}
